import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

const AGBPage = () => {
    const { t } = useTranslation();
    return (
        <div style={{ padding: '20px', color: '#1a202c', maxWidth: '800px', margin: '0 auto', lineHeight: 1.6 }}>
            <Link to="/" style={{ color: '#6366f1', textDecoration: 'none', fontSize: '1.2em' }}>&larr; Back to Map</Link>
            <h1>{t('agb_title')}</h1>
            <p><em>{t('agb_last_updated', { date: '3. März 2026' })}</em></p>

            <h2>1. Geltungsbereich</h2>
            <p>Diese Allgemeinen Geschäftsbedingungen ("AGB") regeln die Nutzung der Plattform "Gonkle" durch natürliche Personen (im Folgenden "Nutzer" oder "Sie"). Betreiber ist Thomas Schmid, Musterstraße 1, 12345 Musterstadt, Deutschland.</p>

            <h2>2. Vertragsgegenstand</h2>
            <p>Gonkle stellt eine Webanwendung zur Verfügung, in der Nutzer Sportveranstaltungen erstellen, veröffentlichen und anderen Nutzern Vermitteln können. Der Dienst ist für private, nicht gewerbliche Zwecke bestimmt.</p>

            <h2>3. Registrierung und Nutzung</h2>
            <p>Die Nutzung der Grundfunktionen erfordert einen Nickname, ein Foto (Selfie) und die Eingabe eines Zugangsschlüssels. Sie sind verpflichtet, bei der Registrierung wahrheitsgemäße Angaben zu machen und Ihren Zugang nicht an Dritte weiterzugeben.</p>

            <h2>4. Pflichten der Nutzer</h2>
            <ul>
                <li>Sie dürfen keine rechtswidrigen Inhalte einstellen oder verbreiten.</li>
                <li>Verstöße gegen Rechte Dritter, insbesondere Urheberrechte, Marken, Persönlichkeitsrechte oder Datenschutz, sind untersagt.</li>
                <li>Sie haben sich im Umgang mit anderen Nutzern rücksichtsvoll und respektvoll zu verhalten.</li>
                <li>Die Nutzung zu kommerziellen Zwecken bedarf der ausdrücklichen Genehmigung des Betreibers.</li>
            </ul>

            <h2>5. Inhalte und Moderation</h2>
            <p>Der Betreiber ist nicht verpflichtet, Inhalte vorab zu prüfen. Er behält sich jedoch das Recht vor, Beiträge, Gonkles oder Nutzerkonten ohne Angabe von Gründen zu löschen oder zu sperren. Bei Kenntnis von rechtswidrigen Inhalten wird der Betreiber diese unverzüglich entfernen und ggf. Strafverfolgungsbehörden informieren.</p>

            <h2>6. Haftung</h2>
            <p>Der Betreiber übernimmt keine Gewähr für die Verfügbarkeit, Vollständigkeit oder Richtigkeit der Inhalte. Bei leicht fahrlässigem Verhalten ist die Haftung ausgeschlossen. Für Schäden, die aus der Nutzung der Plattform entstehen (z. B. Schäden aus persönlichen Treffen, Diebstahl, Körperverletzung), haftet der Betreiber nur bei Vorsatz oder grober Fahrlässigkeit. Eine weitergehende Haftung, insbesondere für entgangenen Gewinn oder indirekte Schäden, ist ausgeschlossen.</p>

            <h2>7. Freistellung</h2>
            <p>Sie stellen den Betreiber von allen Ansprüchen Dritter frei, die aus Ihrer Nutzung der Plattform resultieren, inklusive etwaiger Rechtsanwaltskosten.</p>

            <h2>8. Datenschutz</h2>
            <p>Informationen zur Datenverarbeitung finden Sie in unserer <Link to="/datenschutz" style={{ color: '#6366f1' }}>Datenschutzerklärung</Link>, die Bestandteil dieser AGB ist.</p>

            <h2>9. Änderungen der AGB</h2>
            <p>Der Betreiber kann die AGB jederzeit ändern. Über wesentliche Änderungen wird er mindestens zwei Wochen vor Inkrafttreten informieren. Werden die Änderungen von Ihnen nicht innerhalb eines Monats widersprochen, gelten sie als angenommen.</p>

            <h2>10. Schlussbestimmungen</h2>
            <p>Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Soweit Sie Verbraucher sind, gilt der gesetzliche Gerichtsstand Ihres Wohnsitzes, andernfalls ist ausschließlicher Gerichtsstand für alle Streitigkeiten Berlin, Deutschland. Sollte eine Bestimmung dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Regelungen unberührt.</p>
        </div>
    );
};
export default AGBPage;
